var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alignment"},[[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('h3',{staticClass:"styleHeader"},[_vm._v("\n          "+_vm._s(_vm.$t("pages.User.Index.Utente"))+"\n        ")])]),_c('v-flex',[_c('v-btn',{staticClass:"right white--text styleHeader styleAlignamentAddButton",attrs:{"to":_vm.$i18nRoute({ name: 'UserCreate' }),"color":"#279947"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("add")]),_vm._v("\n          "+_vm._s(_vm.$t("pages.User.Index.Aggiungi"))+"\n        ")],1)],1)],1),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":[
        {
          text: this.currentLanguage.t('pages.User.Index.CodGestionale'),
          align: 'left',
          sortable: true,
          value: 'CodAltKN'
        },
        {
          text: this.currentLanguage.t('pages.User.Index.Azienda'),
          value: 'Company'
        },
        {
          text: this.currentLanguage.t('pages.User.Index.Email'),
          value: 'Email'
        },
        {
          text: this.currentLanguage.t('pages.User.Index.Nome'),
          value: 'Nome'
        },
        {
          text: this.currentLanguage.t('pages.User.Index.Cognome'),
          value: 'Cognome'
        },
        { text: '' }
      ],"items":_vm.users},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.CodAltKN))]),_c('td',[_vm._v(_vm._s(props.item.Company))]),_c('td',[_vm._v(_vm._s(props.item.Email))]),_c('td',[_vm._v(_vm._s(props.item.Nome))]),_c('td',[_vm._v(_vm._s(props.item.Cognome))]),_c('td',[_c('v-btn',{staticClass:"right",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1)],1)]}}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }